import { IMeal } from '../../interfaces/meal';

export class Meal implements IMeal {
  _id: string;
  count: number;
  externalId: string;
  fat: number;
  kcal: number;
  carb: number;
  prot: number;
  measurement: string;
  name: string;
  weight: number;

  constructor(item: IMeal) {
    Object.keys(item).forEach((key) => {
      return (this[key] = item[key as keyof Meal]);
    });
  }

  calculate(nutrient: string): string {
    const value = (this[nutrient] / 100 * this.weight * this.count)
    return value ? value.toFixed(1) : '-'
  }
}

export class Meals {
  meals: IMeal[];

  constructor(items: IMeal[]) {
    this.meals = items.map((item) => new Meal(item));
  }
}
